import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { tsdaBaseQuery } from './baseQuery';

export const eligiblePatientAPI = createApi({
  baseQuery: tsdaBaseQuery,
  reducerPath: 'eligiblePatientAPI',
  endpoints: builder => ({
    getEligiblePatientData: builder.mutation<any, any>({
      query: ({ data,status, from = -1, size = -1 }) => ({
        url: `${formatString(
          endPoints.EligiblePatientAPI.getAll
        )}?status=${status}&application=TSDA&application_section=TSDA&application_module_section=${'TRIAL ELIGIBLE PATIENTS'}${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        method: 'POST',
        body:data
      })
    }),
    updatePatientTrailStatus: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(
          endPoints.EligiblePatientAPI.updateStatus
        )}?application=TSDA&application_section=TSDA&application_module_section=${'TRIAL ELIGIBLE PATIENTS'}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getInTrailPatientData: builder.mutation<any, any>({
      query: ({ from = -1, size = -1 }) => ({
        url: `${formatString(
          endPoints.InTrailPatientAPI.getAll
        )}?application=TSDA&application_section=TSDA&application_module_section=${'TRIAL ELIGIBLE PATIENTS'}${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        method: 'GET'
      })
    }),
    removeInTrailPatientData: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(
          endPoints.InTrailPatientAPI.removeInTrail
        )}?application=TSDA&application_section=TSDA&application_module_section=${'TRIAL ELIGIBLE PATIENTS'}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updatePreScreenStatus: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(
          endPoints.failPreScreenAPI.preScreenUpdateStatus
        )}?application=TSDA&application_section=TSDA&application_module_section=${'TRIAL ELIGIBLE PATIENTS'}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getPreScreenFailPatientData: builder.mutation<any, any>({
      query: ({ from = -1, size = -1 }) => ({
        url: `${formatString(
          endPoints.failPreScreenAPI.getAllPrescreenFail
        )}?application=TSDA&application_section=TSDA&application_module_section=${'TRIAL ELIGIBLE PATIENTS'}${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        method: 'GET'
      })
    })
  })
});

export const {
  useGetEligiblePatientDataMutation,
  useUpdatePatientTrailStatusMutation,
  useGetInTrailPatientDataMutation,
  useRemoveInTrailPatientDataMutation,
  useUpdatePreScreenStatusMutation,
  useGetPreScreenFailPatientDataMutation
} = eligiblePatientAPI;
